// Returns an embeddable iframe URL for YouTube/Vimeo/Google Drive, or null if not embeddable.
export function getEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v");
      if (id) return `https://www.youtube.com/embed/${id}`;
      if (u.pathname.startsWith("/embed/")) return url;
      if (u.pathname.startsWith("/shorts/")) return `https://www.youtube.com/embed/${u.pathname.split("/")[2]}`;
    }
    if (host === "youtu.be") {
      const id = u.pathname.slice(1);
      if (id) return `https://www.youtube.com/embed/${id}`;
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id && /^\d+$/.test(id)) return `https://player.vimeo.com/video/${id}`;
    }
    if (host === "player.vimeo.com") return url;
    if (host === "drive.google.com") {
      // https://drive.google.com/file/d/<ID>/view?usp=sharing  -> /file/d/<ID>/preview
      const m = u.pathname.match(/\/file\/d\/([^/]+)/);
      if (m) return `https://drive.google.com/file/d/${m[1]}/preview`;
      // https://drive.google.com/open?id=<ID>
      const idParam = u.searchParams.get("id");
      if (idParam) return `https://drive.google.com/file/d/${idParam}/preview`;
      if (u.pathname.endsWith("/preview")) return url;
    }
  } catch { /* invalid url */ }
  return null;
}

// Best-effort thumbnail (YouTube only).
export function getYoutubeThumb(url) {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    let id = null;
    if (host === "youtube.com" || host === "m.youtube.com") id = u.searchParams.get("v") || (u.pathname.startsWith("/shorts/") ? u.pathname.split("/")[2] : null);
    if (host === "youtu.be") id = u.pathname.slice(1);
    if (id) return `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
  } catch { /* ignore */ }
  return null;
}
